import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { UserWrapper } from "./Users.styled";
import {
  Input,
  Select_,
  Row,
  Col,
  Switch,
  Form,
  message,
  Checkbox,
} from "components/common";
import { callGetApi } from "utils/api";
import { getUserPermissions } from "utils/text";

const AddNewUser = forwardRef(({ formData, setFormData }, ref) => {
  const [location, setLocation] = useState([]);
  const [accessLevel, setAccessLevel] = useState([]);
  const [level, setLevel] = useState("");
  const [repCom, setRepCom] = useState([]);
  const [check, setCheck] = useState(false);
  const [showDisable, setShowDisable] = useState(true);
  const [getSetter, setGetSetter] = useState([]);

  useImperativeHandle(ref, () => ({
    resetFeilds() {
      setLevel("");
      setCheck(false);
      setShowDisable(true);
    }
  }));

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleActivityChange = (e) => {
    setFormData({ ...formData, active: e });
  };
  const handleLocationChange = (e) => {
    setFormData({ ...formData, locationId: e });
  };
  const handleAccessChange = (e) => {
    setFormData({ ...formData, roleId: e });
    setLevel(e);
  };
  const handleReferrerChange = (e) => {
    let refals = [];
    e.forEach((i) => {
      let filter = getSetter.find((x) => x?._id === i);
      let obj = {
        referrerId: filter?._id,
        referralName: filter?.username,
        refferalProfilePic: filter?.profilePicture === undefined ? "" : filter?.profilePicture,
      }
      refals.push(obj);
    })
    setFormData({
      ...formData,
      referrals: refals
    });
  };
  const handelSetter = (e) => {
    setFormData({
      ...formData,
      repWithSetterCommissionTier: e,
    });
  };
  const handelRep = (e) => {
    setFormData({
      ...formData,
      repCloserCommissionTier: e,
    });
  };
  const changeCheckStatus = (e) => {
    setCheck(e.target.checked);
    setShowDisable(check);
    setFormData({
      ...formData,
      companyCommission: e.target.checked,
    });
  };
  const RepComTiers = () => {
    callGetApi("/repcommission", (data) => {
      setRepCom(data);
    }, (err) => {
      console.log(err);
    }
    );
  };
  const getLocationApi = () => {
    callGetApi("/location", (data) => {
      setLocation(data);
    }, (err) => {
      console.log(err);
    });
  }
  const getRolesApi = () => {
    callGetApi("/roles", (data) => {
      setAccessLevel(data);
    }, (err) => {
      console.log(err);
    });
  }
  const getUsersApi = () => {
    callGetApi("/user", (data) => {
      setGetSetter(data);
    }, (err) => {
      console.log(err);
    });
  }
  const getApi = () => {
    getUsersApi();
    getRolesApi();
    getLocationApi();
  };

  useEffect(() => {
    getApi();
    RepComTiers();
  }, []);

  return (
    <UserWrapper>
      <Row gutter={[10, 10]} style={{ width: "100%" }}>
        <Form>
          <Col span={24}>
            {" "}
            <Form.Item label="Name:">
              <Input
                type="text"
                placeholder="Name"
                className="modal-input"
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            {" "}
            <Form.Item label="Email:">
              <Input
                type="text"
                placeholder="Email"
                className="modal-input"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Form.Item>
          </Col>
          <Col span={24} style={{ marginBottom: "30px" }}>
            {" "}
            <Form.Item label="Location:">
              <Select_
                placeholder="Location"
                options={[
                  ...location.map((el) => {
                    return {
                      name: `${el?.name}, ${el?.state}`,
                      id: el?._id,
                    };
                  })
                ]}
                value={formData.locationId}
                // className="modal-input"
                name
                onChange={handleLocationChange}
              />
            </Form.Item>
          </Col>
          {level === accessLevel[10]?._id && (
            <>
              <Col span={24}>
                {" "}
                <Form.Item label="Sit Pay Amount:">
                  <Input
                    type="text"
                    placeholder="0"
                    className="modal-input"
                    value={formData.sitPayAmount}
                    name="sitPayAmount"
                    onChange={handleChange}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                {" "}
                <Form.Item label="KW Pay:">
                  <Input
                    type="text"
                    placeholder="0"
                    className="modal-input"
                    value={formData.kwPay}
                    name="kwPay"
                    onChange={handleChange}
                  />
                </Form.Item>
              </Col>
            </>
          )}
          {level === accessLevel[7]?._id && (
            <Col span={24}>
              {" "}
              <Form.Item label="Manager Override:">
                <Input
                  type="text"
                  placeholder="0"
                  className="modal-input"
                  name="override"
                  value={formData.override}
                  onChange={handleChange}
                />
              </Form.Item>
            </Col>
          )}
          {level === accessLevel[9]?._id && (
            <Col span={24}>
              {" "}
              <Form.Item label="Per Sit Amount:">
                <Input
                  type="text"
                  placeholder="0"
                  className="modal-input"
                  value={formData.perSitAmount}
                  name="perSitAmount"
                  onChange={handleChange}
                />
              </Form.Item>
            </Col>
          )}
          {level === accessLevel[8]?._id && (
            <>
              <Col span={24}>
                <Form.Item label="Setter Commission Tier:">
                  <Select_
                    className="modal-input"
                    placeholder="Setter Commission Tier"
                    name
                    options={repCom}
                    value={formData.repWithSetterCommissionTier}
                    onChange={handelSetter}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Closer Commission Tier:">
                  <Select_
                    className="modal-input"
                    placeholder="Closer Commission Tier"
                    name
                    options={repCom}
                    onChange={handelRep}
                  />
                </Form.Item>
              </Col>
            </>
          )}
          <Col span={24}>
            {" "}
            <Form.Item label="Access Level">
              <Select_
                placeholder="Access Level"
                options={[
                  ...accessLevel.map((el) => {
                    return {
                      name: el?.role,
                      id: el?._id,
                    };
                  })
                ]}
                value={formData.roleId}
                className="modal-input-select"
                name
                onChange={handleAccessChange}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Recruits By">
              <Select_
                placeholder=" Select Recruits"
                button
                buttonTitle="Filter"
                options={[
                  ...getSetter?.map((el) => {
                    return {
                      name: el?.username,
                      id: el?._id,
                    };
                  }),
                ]}
                mode="multiple"
                name
                showSearch
                onChange={handleReferrerChange}
              />
            </Form.Item>
          </Col>
          {getUserPermissions("company-commission-view") && (
            <Col span={24}>
              {" "}
              <Form.Item
              // alabel="Company Commission"
              >
                <Row>
                  <Col xs={24} sm={9} lg={9}>
                    <label style={{ width: "100%" }}>Company Commission:</label>
                  </Col>
                  <Col xs={24} sm={15} lg={15} className="company-input-col">
                    <Checkbox
                      checked={formData?.companyCommission || check}
                      className="modal-check"
                      name="companyCommission"
                      onChange={changeCheckStatus}
                    />
                  </Col>
                </Row>
              </Form.Item>
            </Col>
          )}
          {getUserPermissions("company-commission-view") && (
            <Col span={24}>
              {" "}
              <Form.Item
              // label={
              //   <label>
              //     Company Commission <br /> Amount:
              //   </label>
              // }
              >
                <Row>
                  <Col xs={24} sm={9} lg={9}>
                    <label style={{ width: "100%" }}>
                      Company Commission Amount:
                    </label>
                  </Col>
                  <Col xs={24} sm={15} lg={15} className="company-input-col">
                    {" "}
                    <Input
                      disabled={showDisable}
                      value={formData.companyKW}
                      placeholder="Enter Company Commission Amount"
                      className="modal-input"
                      name="companyKW"
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
              </Form.Item>
            </Col>
          )}
          <Col span={24} className="switch-col">
            <Form.Item label="Closer">
              <Switch
                checkedChildren="True"
                unCheckedChildren="False"
                onChange={handleActivityChange}
              />
            </Form.Item>
          </Col>
        </Form>
      </Row>
    </UserWrapper>
  );
});

export default AddNewUser;
